export const ACCESS_PAGE_COOKIE_NAME = "accessPage";
